import { Field, Label } from '@headlessui/react';
import { useNavigate } from '@remix-run/react';
import { cn, getSamedayName } from '@theprintbar/shared';
import { useEffect, useState } from 'react';
import { LightningBolt, Pill, Toggle } from '../../../components';
import { FilterListProps } from './FilterList';
import { ProductQueryKeys, getProductSearchURL } from './productSearch';

type SamedayToggleProps = Pick<FilterListProps, 'store' | 'params'> & {
	className?: string;
	fieldClassName?: string;
	labelClassName?: string;
	disabled?: boolean;
};

export function SamedayToggle({ disabled, store, params, className, fieldClassName, labelClassName }: SamedayToggleProps) {
	const navigate = useNavigate();
	const [enabled, setEnabled] = useState(false);
	const [decorationCompatible, setDecorationCompatible] = useState(true);

	const samedayName = getSamedayName();

	const decoration = params[ProductQueryKeys.Decoration];
	const incompatibleDecorations = ['emb', 'scr', 'dtf'];

	useEffect(() => {
		// Sameday not available for embroidery or screen printing
		setDecorationCompatible(decoration ? !incompatibleDecorations.includes(decoration) : true);
		setEnabled(decorationCompatible && !!params[ProductQueryKeys.Sameday]);
	}, [params, decorationCompatible]);

	const samedayUrl = getProductSearchURL(ProductQueryKeys.Sameday, !params[ProductQueryKeys.Sameday], params);

	return store ? null : (
		<Field as="div" className={cn('flex items-center', fieldClassName, !decorationCompatible && 'pointer-events-none')}>
			<Label className={cn('cursor-pointer w-full text-xs pr-4', labelClassName)}>
				<h5 className="uppercase">Need it ASAP?</h5>
				<p>Order {samedayName}</p>
			</Label>
			<Pill
				className={cn(
					'absolute -top-3 left-4 md:static uppercase pl-2 md:pl-3 py-0 pr-0 md:mr-4 flex items-center font-belfast text-xs font-bold whitespace-nowrap gap-2',
					'bg-blue-mid',
					className,
				)}
			>
				{samedayName}
				<Toggle
					name="sameday"
					enabledClassName={'bg-blue-bright'}
					enabled={enabled}
					disabled={disabled || !decorationCompatible}
					disabledClassName="bg-white border-blue text-blue"
					disabledIconClassName="bg-blue rounded-full text-white"
					enabledIcon={LightningBolt}
					disabledIcon={LightningBolt}
					onChange={() => {
						setEnabled(!enabled);
						navigate(samedayUrl);
					}}
					className="ml-auto -my-px -mr-px"
					innerLabel
				/>
			</Pill>
		</Field>
	);
}
